<script>
import THelp from '~/components/THelp';

export default {
  extends: THelp,

  props: {
    label: {
      type: String,
      required: false,
      default: 'Stellen Sie Ihr Unternehmen in einem kurzen Text (max. 7 Sätze) vor.',
    },
  },
};
</script>
